(() => {
  const template = document.getElementById('orrling-nivoda-intro-template');
  if (!template) return;
  let pending = false;
  const sync = () => {
    pending = false;
    const root = document.getElementById('diamond-proxy-root');
    if (!root) return;
    document.body.classList.add('orrling-nivoda-page');
    let intro = document.querySelector('.orrling-nivoda-intro');
    if (!intro) {
      root.before(template.content.cloneNode(true));
      intro = document.querySelector('.orrling-nivoda-intro');
    }
    const stage = new URLSearchParams(location.search).get('stage');
    const loose = template.dataset.loose === 'true';
    const key = loose ? 'loose' : stage === 'Complete Ring' ? 'complete' : stage === 'Add Diamond' ? 'diamond' : 'setting';
    root.dataset.orrlingStage = loose ? 'diamond' : key;
    intro.querySelectorAll('h1,p').forEach(el => {
      if (el.textContent !== el.dataset[key]) el.textContent = el.dataset[key];
    });
    const main = document.getElementById('MainContent');
    main.querySelectorAll('h1').forEach(el => {
      if (!intro.contains(el) && !root.contains(el)) el.closest('.shopify-section')?.classList.add('orrling-nivoda-original-title');
    });
    const summary = root.querySelector('.diamond-proxy-ring-summary');
    if (summary) {
      const rows = summary.children[1];
      if (rows && !rows.classList.contains('diamond-proxy-add-to-cart') && rows.children.length === 3) {
        rows.classList.add('orrling-nivoda-rows');
        [...rows.children].forEach(row => row.classList.add('orrling-nivoda-row'));
      }
      if (!summary.querySelector('.orrling-nivoda-help')) summary.append(document.getElementById('orrling-nivoda-help-template').content.cloneNode(true));
      summary.querySelectorAll('a').forEach(a => a.classList.add('my-animated-link'));
      summary.querySelectorAll('div').forEach(el => {
        if (!el.children.length && /^(View|Remove)$/.test(el.textContent.trim())) el.classList.add('my-animated-link');
      });
    }
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(sync); } };
  new MutationObserver(schedule).observe(document.getElementById('MainContent') || document.body, {childList:true,subtree:true,characterData:true});
  window.addEventListener('popstate', schedule);
  window.addEventListener('pageshow', schedule);
  sync();
})();
